/**
 * Shared date formatting — "12-Jan-2026" style.
 */

export const formatDate = (d) => {
  if (!d) return ' - ';
  try {
    const date = d.includes?.('T') ? new Date(d) : new Date(d + 'T00:00:00');
    // "12 Jan 2026" → "12-Jan-2026"
    return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
      .replace(/ /g, '-');
  } catch { return ' - '; }
};

export const formatDateTime = (d) => {
  if (!d) return ' - ';
  try {
    const date = new Date(d);
    const datePart = date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }).replace(/ /g, '-');
    const timePart = date.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
    return `${datePart} ${timePart}`;
  } catch { return ' - '; }
};

export const formatChartDate = (d) => {
  if (!d) return '';
  try {
    return new Date(d + 'T00:00:00').toLocaleDateString('en-GB', { day: '2-digit', month: 'short' })
      .replace(/ /g, '-');
  } catch { return d; }
};
